import React from 'react';
import '../../styles/ContactPage.scss';
import backIcon from '../../img/Back.svg';
import { useNavigate } from 'react-router-dom';
import translations from '../../translate';

const ContactPage = () => {
  const navigate = useNavigate();
  const selectedLanguage = localStorage.getItem('language') || 'en';
  const text = translations[selectedLanguage];

  return (
    <div className="contact-page">
      <div className="title-container">
        <img
          src={backIcon}
          alt={text.back}
          className="back-icon"
          onClick={() => navigate('/main')}
        />
        <h2 className="title">{text.contacts}</h2>
      </div>

        <div className="contact-card">
    <p><strong>{text.phone}:</strong> +371 12345678</p>
    <p><strong>{text.email}:</strong> info@stalkerwind.com</p>
    <p><strong>{text.address}:</strong> {text.addressFull}</p>
    <p><strong>{text.workingHours}:</strong> {text.workingHoursTime}</p>
    </div>


      <div className="map-container">
        <iframe
          title="Google Karte"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2175.234!2d24.0501185!3d56.9063102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTbCsDU0JzIyLjciTiAyNMKwMDMnMDAuNCJF!5e0!3m2!1slv!2slv!4v1643723600000!5m2!1slv!2slv"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPage;